






























































import { Prop, Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DataSet, ChartOptions, MyOptions } from "@/charts/graphData";
import jsonURLTotal from "@/shared/UrlsTotal";
import LineChart from "@/charts/LineChart.vue";
import moment from "moment/moment";
import TotalGraphMixin from "./totalGraphMixins";
import ChartsCommon from "./chartsMixin";

@Component({
  components: {
    LineChart,
  },
})
export default class CaTotalGraph extends mixins(
  TotalGraphMixin,
  ChartsCommon
) {
  public dataGetted = false;
  // public labels: Array<string> = [];
  public data: Array<DataSet> = [];
  public options: ChartOptions = new ChartOptions();
  public config: any;
  public localLabels: string[] = [];
  public dataSetMonth: {
    day: Array<DataSet>;
    quart: Array<DataSet>;
    labels: { day: Array<string>; quart: Array<string> };
  } = { day: [], quart: [], labels: { day: [], quart: [] } };
  public dataSets: { vente: Array<DataSet>; presta: Array<DataSet> } = {
    vente: [],
    presta: [],
  };
  public filtre = "PRESTA";
  public filtreDay = "DAY";

  @Prop() public myOptions!: MyOptions;
  @Prop() public type!: string;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public init() {
    if (this.myOptions.site.length === 0) {
      return;
    }
    this.dataGetted = false;
    this.config = {
      site: this.myOptions.site,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.updateWs();

    const titre =
      this.type === "ca"
        ? this.$t("Ca").toString() + "(€)"
        : this.$t("VentillationParEquipement").toString() + "(€)";
    this.orderTitre(this.myOptions, titre);

    this.$store
      .dispatch("home/getGraphData", { config: this.config, p: -1 })
      .then((data: any) => {
        if (this.type !== "ca") {
          this.orderDataEquip(data);

          this.orderDataEquip(data);
          this.ApplyFilter();
          this.options.makeMeACategoryLineGraph();
        } else {
          if (this.myOptions.periode === "J") {
            data = this.quartFilterDate(data);
          } else {
            data = this.makeDataFull(
              this.myOptions.periode as "MOIS" | "ANNEE",
              data
            );
            if (this.myOptions.periode === "MOIS") {
              this.config.WS = jsonURLTotal.PRESTA_QUART_SUR_MOIS;
              this.$store
                .dispatch("home/getGraphData", { config: this.config, p: -1 })
                .then((dataq: any) => {
                  const [venteParHeure, prestaParHeure] =
                    this.convertQuartArrayToHour(dataq);
                  const dataQuart = [venteParHeure, prestaParHeure];
                  this.makeMonthDataSet(data, dataQuart);
                });
            }
          }

          this.orderData(data);
          this.setOptions();
        }
      });
  }

  /**
   * methode permettant d'appliquer un filtre permettant de choisir le graph à afficher
   * vente ou presta
   */
  public ApplyFilter() {
    if (this.filtre === "VENTE") {
      this.data = this.dataSets.vente;
    } else if (this.filtre === "PRESTA") {
      this.data = this.dataSets.presta;
    }
  }

  /**
   * methode permettant d'appliquer un filtre permettant de choisir le graph à afficher
   * par jour ou par quart
   */
  public ApplyFilterDay() {
    // console.log("filtre mon jour", this.filtreDay);
    if (this.filtreDay === "JOUR") {
      this.data = this.dataSetMonth.day;
      this.localLabels = this.dataSetMonth.labels.day;
      this.options.updateLegendPeriod("MOIS");
    } else if (this.filtreDay === "QUART") {
      this.data = this.dataSetMonth.quart;
      this.localLabels = this.dataSetMonth.labels.quart;
      this.options.updateLegendPeriod("QUART_JOUR");
    }
  }

  /**
   * methode de maj du web service a interoger selon le type de graph demandé et la période
   */
  private updateWs() {
    switch (this.myOptions.periode) {
      case "J":
        this.config.WS =
          this.type === "ca"
            ? jsonURLTotal.PRESTA_QUART_SUR_JOUR
            : jsonURLTotal.PRESTA_QUART_SUR_JOUR_PAR_EQUIPEMENT;
        break;
      case "MOIS":
        this.config.WS =
          this.type === "ca"
            ? jsonURLTotal.PRESTA_JOUR_SUR_MOIS
            : jsonURLTotal.PRESTA_QUART_SUR_MOIS_PAR_EQUIPEMENT;
        break;
      case "ANNEE":
        this.config.WS =
          this.type === "ca"
            ? jsonURLTotal.PRESTA_MOIS_SUR_ANNEE
            : jsonURLTotal.PRESTA_QUART_SUR_ANNEE_PAR_EQUIPEMENT;
        break;
    }
  }

  /**
   * methode permettant de mettre à jour les options du graphique
   */
  private setOptions() {
    this.options.showLegend(true);
    // this.options.setTitleTxt(this.titre);
    if (this.type === "ca") {
      this.options.updateLegendPeriod(this.myOptions.periode);
    } else {
      this.options.updateLegendPeriod("J");
    }
    this.options.hideLabelPlugin();
    this.options.showYLegend(true);
  }

  /**
   * mise en forme des données recues du serveur pour pouvoir construire les graphs
   */
  private orderData(lignes: any) {
    this.data = [];

    const dataVente: number[] = [];
    const dataPresta: number[] = [];
    if (this.myOptions.periode === "ANNEE") {
      this.localLabels = this.generateMonthlyLabels();
    } else {
      this.localLabels = Object.keys(lignes[0]).sort((a, b) =>
        moment(a).diff(moment(b))
      );
    }

    this.localLabels.forEach((label: string) => {
      dataVente.push(lignes[0][label] != null ? lignes[0][label] : 0);
      dataPresta.push(lignes[1][label] != null ? lignes[1][label] : 0);
    });
    const dataSetVente = new DataSet();
    dataSetVente.data = dataVente;
    dataSetVente.borderColor = this.colorsComplex[1].borderColor;
    dataSetVente.backgroundColor = this.colorsComplex[1].backgroundColor;
    dataSetVente.label = this.$t("VENTE").toString();

    const dataSetPresta = new DataSet();
    dataSetPresta.data = dataPresta;
    dataSetPresta.label = this.$t("PRESTA").toString();

    this.data.push(dataSetVente);
    this.data.push(dataSetPresta);
    this.dataGetted = true;
  }

  /**
   * mise en forme des data equipement pour le graph
   */
  private orderDataEquip(lignes: any) {
    this.dataSets = { vente: [], presta: [] };
    this.data = [];
    this.localLabels = [];

    const equipements = Object.keys(lignes);
    if (equipements.length === 0) {
      return;
    }

    const premierEquipement = equipements[0];
    const premierData = lignes[premierEquipement];
    this.localLabels = Object.keys(premierData);

    for (let i = 0; i < equipements.length; i++) {
      const equipement = equipements[i];
      const dataByTime = lignes[equipement];

      const ventes: number[] = [];
      const prestas: number[] = [];

      for (const label of this.localLabels) {
        const data = dataByTime[label];

        if (data && data.length > 0) {
          ventes.push(data[1] !== undefined ? data[1] : 0);
          prestas.push(data[2] !== undefined ? data[2] : 0);
        } else {
          ventes.push(0);
          prestas.push(0);
        }
      }

      // Vente
      const dataSetVente = new DataSet();
      dataSetVente.data = ventes;
      dataSetVente.label = equipement;
      if (this.colorsComplex[i]) {
        dataSetVente.borderColor = this.colorsComplex[i].borderColor;
        dataSetVente.backgroundColor = this.colorsComplex[i].backgroundColor;
      }

      // Presta
      const dataSetPresta = new DataSet();
      dataSetPresta.data = prestas;
      dataSetPresta.label = equipement;
      if (this.colorsComplex[i]) {
        dataSetPresta.borderColor = this.colorsComplex[i].borderColor;
        dataSetPresta.backgroundColor = this.colorsComplex[i].backgroundColor;
      }

      // On ajoute les deux si au moins une des valeurs est non vide
      if (ventes.some((v) => v > 0)) {
        this.dataSets.vente.push(dataSetVente);
      }

      if (prestas.some((p) => p > 0)) {
        this.dataSets.presta.push(dataSetPresta);
      }
    }

    /**
     * L'API nous renvoie les quart d'heure dans une ordre chaotique
     * On les trie avant de les afficher dans le graphique
     */
    this.localLabels = this.localLabels
      .slice()
      .sort((a, b) => parseInt(a.split(":")[0]) - parseInt(b.split(":")[0]))
      .map(this.convertQuartIndexToHour);

    this.dataGetted = true;
  }

  private generateMonthlyLabels(): string[] {
    const start = moment().startOf("year");
    return [...Array(12)].map((_, i) =>
      start.clone().add(i, "months").format("YYYY-MM-01T00:00:00.000+0000")
    );
  }

  /**
   * mise en forme des data en dataSet
   */
  private makeMonthDataSet(dataDay: any, dataQuart: any) {
    const dataDayOrder = this.makeMeADataset(dataDay, this.getFixedColors());
    this.dataSetMonth.day = dataDayOrder.datasets;
    this.dataSetMonth.labels.day = dataDayOrder.labels;
    if (dataQuart && typeof dataQuart === "object") {
      const dataQuartOrder = this.makeMeADataset(
        dataQuart,
        this.getFixedColors()
      );
      this.dataSetMonth.quart = dataQuartOrder.datasets;
      this.dataSetMonth.labels.quart = dataQuartOrder.labels;
    } else {
      console.warn("⚠️ Données dataQuart invalides :", dataQuart);
    }
  }
  private getFixedColors() {
    return [
      {
        borderColor: "#EF5350",
        backgroundColor: "rgba(239, 83, 80, 0.2)",
      },
      {
        borderColor: "#ffffff",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
      },
    ];
  }
}
